import {connect} from 'react-redux';
import {denormalize} from 'normalizr';

import {schema} from '../../../../../state/schema';
import {loadJournalTags, deleteJournalTag} from '../../../../../state/modules/journalTags/actions';
import {sendMessage} from '../../../../../state/actions';
import JournalTagsList from '../components/JournalTagsList';

const mapStateToProps = (state, ownProps) => {

  const page = ownProps.page;
  const limit = ownProps.limit;
  const order = ownProps.order;
  const result = state.journalTags.getIn(['pages', order, limit, page]);

  return {
    list: result 
      ? result.map(x => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['journalTags', x]),
              schema.journalTag,
              state.entities.toJS()
            )
          };
        }).toArray()
      : [],
    isLoading: state.journalTags.get('isLoading'),
    total: state.journalTags.get('total'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    load: (page, limit, order, filter, cb) => {
      dispatch(loadJournalTags(page, limit, order, filter, cb));
    },
    remove: (id, cb) => {
      dispatch(deleteJournalTag(id, cb));
    },
    sendMessage: (level, title, body, expires) => {
      dispatch(sendMessage(level, title, body, expires));
    },
  }
}

const JournalTagsListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(JournalTagsList);

export default JournalTagsListContainer;
